<template>
  <v-container
    id="login-view"
    class="fill-height"
    tag="section"
  >
    <v-row justify="center">
      <v-col cols="12">
        <v-slide-y-transition appear>
          <material-card
            light
            max-width="350"
            rounded
            class="mx-auto"
            color="accent"
            full-header
          >
            <template #heading>
              <div class="text-center pa-5">
                <div class="text-h4 font-weight-bold white--text">
                  {{ $t('login') }}
                </div>
                <div class="mt-4">
                  <v-btn
                    v-for="(social, i) in (socials)"
                    :key="i"
                    icon
                    class="mx-2"
                    :href="social.href"
                  >
                    <v-icon>
                      {{ social.icon }}
                    </v-icon>
                  </v-btn>
                </div>
              </div>
            </template>

            <v-card-text class="text-center">
              <div class="text-center font-weight-light">
                {{ $t('or_be_classical') }}
              </div>

              <validation-provider
                v-slot="{ errors }"
                name="email"
                rules="required|email"
              >
                <v-text-field
                  v-model="email"
                  :error-messages="errors"
                  color="secondary"
                  type="email"
                  :placeholder="$t('email')+'...'"
                  prepend-icon="$email"
                />
              </validation-provider>
              <v-text-field
                v-model="password"
                class="mb-0"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show ? 'text' : 'password'"
                color="secondary"
                :placeholder="$t('password')+'...'"
                prepend-icon="mdi-lock-outline"
                @click:append.prevent="show = !show"
              />
              <div class="text-right">
                <a
                  class="text-decoration-underline text--secondary black--text text-overline"
                  @click="passwordReminder"
                >
                  {{ $t('send_password_reminder') }}
                </a>
              </div>
              <v-col class="py-0">
                <v-btn
                  v-shortkey.once="['enter']"
                  color="accent"
                  class="my-6"
                  rounded
                  text
                  large
                  @shortkey="auth"
                  @click="auth"
                >
                  {{ $t('lets_go') }}
                </v-btn>
              </v-col>
              <div class="text-center">
                {{ $t('first_time_in_site') }} <a class="text-decoration-underline" @click="register"> {{ $t('register_now') }} </a>
              </div>
            </v-card-text>
          </material-card>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // Utilities
  import { call, get } from 'vuex-pathify'

  export default {
    name: 'LoginView',
    data () {
      return {
        error: false,
        show: false,
        email: '',
        password: '',
        loading: false,
        lang: 'hu',
        languages: ['en', 'hu', 'de', 'it', 'fr', 'pl', 'sk', 'cz'],
        socials: [
          {
            href: process.env.VUE_APP_API_URL + '/auth/facebook',
            icon: '$facebook',
          },
          /* {
            href: '/auth/twitter',
            icon: 'mdi-twitter',
          }, */
          {
            href: process.env.VUE_APP_API_URL + '/auth/google',
            icon: '$google',
          },
          /* {
            href: '/auth/github',
            icon: 'mdi-github',
          }, */
        ],
      }
    },
    computed: {
      logged_in: get('auth/logged_in'),
      redirect: get('auth/redirect'),
      // user: get('auth/user'),
    },
    mounted () {
      const navLang = this.languages.includes(navigator.language) ? navigator.language : 'en'
      console.log('Nav Lang:' + navLang)
      this.lang = this.$route.params.lang ?? navLang
      this.localeChange({ lang: this.lang, login: true })
      if (process.env.VUE_APP_USER) {
        this.email = process.env.VUE_APP_USER
        this.password = process.env.VUE_APP_PASS
      }
    },
    methods: {
      login: call('auth/login'),
      authenticate: call('auth/authenticate'),
      localeChange: call('app/localeChange'),
      auth () {
        this.error = false

        this.loading = true

        this.login({
          email: this.email,
          password: this.password,
        }).then(response => {
          this.loading = false
          console.log('sikeres belépés')

          // next
          if (this.$route.name === 'DailyFlight/Login') {
            this.$router.push('/daily-flight').catch(() => {})
          } else {
            this.$router.push(this.redirect).catch(() => {})
          }

          // console.log(this.user)
          /*
          this.$router.push({
            name: 'tables/regular/',
          }).then((e) => {
            // window.location.href = window.location.href
          }).catch(e => {
            console.log('valami gebasz van')
            console.log(e)
          }) */
        }).catch(e => {
          console.log(e)
          this.loading = false
          self.error = true
        })
      },
      AuthProvider (provider) {
        var self = this
        this.authenticate(provider).then(response => {
          self.SocialLogin(provider, response)
        }).catch(err => {
          console.log({ err: err })
        })
      },
      register () {
        this.$router.push('/register').catch(() => {})
      },
      passwordReminder () {
        this.$router.push('/password-reminder').catch(() => {})
      },
    },
  }
</script>
